"use client";

import { motion, useMotionTemplate, useMotionValue } from "framer-motion";
import { MouseEvent } from "react";

export default function PerspectiveGrid() {
    const mouseX = useMotionValue(0);
    const mouseY = useMotionValue(0);

    function handleMouseMove({ currentTarget, clientX, clientY }: MouseEvent) {
        let { left, top, width, height } = currentTarget.getBoundingClientRect();

        mouseX.set((clientX - left) / width);
        mouseY.set((clientY - top) / height);
    }

    return (
        <div
            className="absolute inset-0 overflow-hidden perspective-1000 z-0 bg-transparent"
            style={{
                maskImage: "radial-gradient(ellipse at 50% 30%, black 20%, transparent 90%)",
                WebkitMaskImage: "radial-gradient(ellipse at 50% 30%, black 20%, transparent 90%)"
            }}
            onMouseMove={handleMouseMove}
        >
            <motion.div
                className="absolute inset-[-50%] w-[200%] h-[200%] origin-center"
                style={{
                    rotateX: useMotionTemplate`${mouseY.get() * 20 + 20}deg`, // Default tilt plus mouse influence
                    rotateY: useMotionTemplate`${(mouseX.get() - 0.5) * 20}deg`,
                    backgroundImage: `
                        linear-gradient(to right, rgba(0,0,0,0.05) 1px, transparent 1px),
                        linear-gradient(to bottom, rgba(0,0,0,0.05) 1px, transparent 1px)
                    `,
                    backgroundSize: "60px 60px",
                }}
                animate={{
                    backgroundPosition: ["0px 0px", "0px 60px"]
                }}
                transition={{
                    repeat: Infinity,
                    duration: 2,
                    ease: "linear",
                }}
            />
        </div>
    );
}
